<template>
<div>
  <b-button v-b-modal.login_modal v-if="!authenticated">Log ind</b-button>
  <b-button v-if="authenticated" @click="logout">Log ud</b-button>
  <b-modal id="login_modal" ref="login_modal" title="MBN Admininistration">
    <b-form-group id="login_username_group" label="email:" label-for="login_username">
      <b-form-input id="login_username" v-model="email" type="email" required placeholder="name@host.dk" />
    </b-form-group>
    <b-form-group id="login_passoword_group" label="Password:" label-for="login_password">
      <b-form-input id="login_password" v-model="password" type="password" required placeholder="password" @keydown.native.enter="login" />
    </b-form-group>
    <b-alert :show="authenticationError" variant="danger" dismissible fade @dismissed="authenticationError=false">{{ authenticationErrorMessage }}</b-alert>
    <div slot="modal-footer" class="w-100">
      <b-button-group class="float-right">
        <b-button @click="cancel">
          Cancel
        </b-button>
        <b-button variant="primary" @click="login">
          Login
        </b-button>
      </b-button-group>
    </div>
  </b-modal>
</div>
</template>

<script>
import {
  auth
} from '../config/firebase';
export default {
  name: 'Navigation',
  components: {},
  data() {
    return {
      email: undefined,
      password: undefined,
      authenticationError: false,
      authenticationErrorMessage: undefined
    }
  },
  computed: {
    authenticated() {
      return this.$store.state.authenticated;
    }
  },
  methods: {
    login() {
      auth.signInWithEmailAndPassword(this.email, this.password).then((user) => {
        this.$store.commit('setUid', user.user.uid)
        this.$refs.login_modal.hide()
      }).catch((err) => {
        this.authenticationError = true
        this.authenticationErrorMessage = err.message
      })
    },
    logout() {
      let that = this
      auth.signOut().then(function () {
        that.$store.commit('setUid', null)
        that.$refs.login_modal.hide()
      }).catch(function (err) {
        this.authenticationError = true
        this.authenticationErrorMessage = err.message
      });
    },
    cancel: function () {
      this.$refs.login_modal.hide()
    },
  }
}
</script>

<style scoped>
</style>
